import styled from 'styled-components'

import { FormattedPercent } from '@10xLabs/react-web/components/FormattedPercent'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import { DISCOUNT_TYPE } from 'features/Coupons/components/DiscountType/constants'
import { ReactElement } from 'react'
import { ICouponDetailsProps } from './types'
import { GTBookingV2CouponDiscountType } from 'gql/types.generated'

const CouponWrapper = styled.div<TSFixMe>`
  margin-top: 20px;
  display: flex;
  align-items: center;
`

const CouponCode = styled.div<TSFixMe>`
  padding: 2px 6px;
  font-size: 13px;
  background-color: #ecebf4;
  border-radius: 4px;
  text-transform: uppercase;
  margin-right: 5px;
`

export const CouponDetails = ({ coupon }: ICouponDetailsProps): ReactElement | null => {
  if (!coupon) {
    return null
  }

  return (
    <CouponWrapper>
      <CouponCode>{coupon.code}</CouponCode>

      {coupon.discountType === DISCOUNT_TYPE.PERCENTAGE ||
      coupon.discountType === GTBookingV2CouponDiscountType.Percentage ? (
        <FormattedPercent value={coupon.value} />
      ) : (
        <FormattedPrice value={coupon.value} />
      )}
    </CouponWrapper>
  )
}
